import { get } from "lodash-es";
import { Validate, FieldValues } from "react-hook-form";

export const DEFAULT_STRING_LENGTH = 256;

type ValidatorFunction<T, F = FieldValues> = Validate<T, F>;

const transformArrayPath = (path: string): string => {
  // Transform dot notation with array indices to bracket notation
  // e.g., "items.0.values.1.name" -> "items[0].values[1].name"
  return path.replace(/\.(\d+)\./g, "[$1].");
};

export const getPredefinedValueUniqueValidator = <
  T extends string,
  FieldName extends string,
>(
  valuesPath: string,
  valueProperty: FieldName = "value" as FieldName,
): ValidatorFunction<T> => {
  return (currentValue, formValues) => {
    const transformedPath = transformArrayPath(valuesPath);
    const values = get(formValues, transformedPath, []) as {
      [key in FieldName]: T;
    }[];

    const duplicateCount = values
      .map((val) => val[valueProperty])
      .filter((value) => value === currentValue).length;

    return duplicateCount > 1 ? "Value must be unique" : true;
  };
};
